module.exports = __webpack_public_path__ + "assets/img/activity_618_btn_bg.7bdca1f3.png";